export const TYPE_INDIVIDUAL = 0;

export const TYPE_COMPANY = 1;

export const GENDER_MALE = 1;

export const OPENING_AREA_SAME = 1;

export const TYPE_SCOUT = 1;

export const TYPE_APPLY = 2;

export const OPENING_AREAS = [
    {
        id: 1,
        label: '現住所と同じ都道府県内',
    },
    {
        id: 2,
        label: '現住所と隣接する都道府県内',
    },
    {
        id: 0,
        label: '希望なし',
    },
];

export const GENDER = [
    {
        id: 1,
        label: '男性',
    },
    {
        id: 2,
        label: '女性',
    },
    {
        id: 0,
        label: '選択しない',
    },
];

export const OPENING_FUNDS = [
    {
        id: 100,
        label: '0~100万円',
    },
    {
        id: 200,
        label: '101~200万円',
    },
    {
        id: 300,
        label: '201~300万円',
    },
    {
        id: 400,
        label: '301~400万円',
    },
    {
        id: 500,
        label: '401~500万円',
    },
    {
        id: 600,
        label: '501~600万円',
    },
    {
        id: 700,
        label: '601~700万円',
    },
    {
        id: 800,
        label: '701~800万円',
    },
    {
        id: 900,
        label: '801~900万円',
    },
    {
        id: 1000,
        label: '901~1,000万円',
    },
    {
        id: 1001,
        label: '1,000万円以上',
    },
];
